<template>
  <div class="Alert fixed-t col-12 t-c-v pt30" v-if="type">
    <transition name="fade">
    <div class="w30 r5 p10 h5" :class="type">
      <div class="col-2"><i class="iconfont f26 mr10" :class="{'icon-gou color-success': type == 'success','icon-warning-filling color-warning': type == 'warn','icon-x color-danger': type == 'error','icon-infofill color-info': type == 'info'}"></i></div>
      <div class="col-10 pt5"><span class="f14 fw">{{msg}}</span></div>
    </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Alert',
    props: {
    msg: String,
    type: String
  },
  created: function () {
    setInterval(() => {
      this.$store.commit('setAlert',{type:''})
    }, 3000);
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.success{
  background-color: #DEF2D6;
  color: #5B7153;
  border: 1px solid #5B7153;
}
.error{
  background-color: #ECC8C5;
  color: #CA6E6C;
  border: 1px solid #CA6E6C;
}
.warn{
  background-color: #F8F3D6;
  color: #977234;
  border: 1px solid #977234;
}
.info{
  background-color: #CDE8F5;
  color: #4883B0;
  border: 1px solid #4883B0;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .8s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Alert.vue